const forms = () => {
    const initLabel = (input) => {
        input.on('focus', (ev) => {
            $(ev.currentTarget).closest('label').find('.label').addClass('label--active');
        });

        input.on('blur', () => {
            for (let i = 0; i < input.length; i++) {
                let val = input.eq(i).val();
                if (val === "") {
                    input.eq(i).closest('label').find('.label').removeClass('label--active');
                }
            }
        });
    };

    let forms = $('.wpcf7 form');

    $(forms).on('submit', function(ev){
        const form = $(ev.currentTarget),
            btn = form.find('.btn-wrapper');

        btn.addClass('preloader');
    })

    $(forms).on('wpcf7submit', function(ev) {
        const form = $(ev.currentTarget),
            label = form.find('.label'),
            btn = form.find('.btn-wrapper');

        btn.removeClass('preloader');

        if (form.attr('data-status') === 'invalid') {
            label.addClass('invalid').removeClass('valid');
        } else {
            label.addClass('valid').removeClass('invalid');
        }
    })

    $(forms).on('wpcf7mailsent', function(ev){
        const form = $(ev.currentTarget),
            btn = form.find('.btn-wrapper');

        btn.removeClass('preloader').addClass('send-success');

        btn.find('.btn-new__text').html(ajax_url['sendMessage']);
    })


    $(forms).on('wpcf7spam', function(ev){
        const form = $(ev.currentTarget),
            btn = form.find('.btn-wrapper');

        btn.removeClass('preloader');
    })


    $(forms).on('wpcf7mailfailed ', function(ev){
        const form = $(ev.currentTarget),
            btn = form.find('.btn-wrapper');

        btn.removeClass('preloader');
    })

    forms.each((i, el) => {
        const input = $(el).find("input:not([type='submit']):not([type='checkbox']):not([type='radio']):not([type='file']):not([type='search']):not([type='hidden'])");
        input.each((i, el) => {
            const label = $(el).closest('label').find('.label');
            $(el).blur(function () {
                if ($(el).attr('aria-invalid') === 'true') {
                    label.addClass('invalid').removeClass('valid');
                } else {
                    label.addClass('valid').removeClass('invalid');
                }
            });

            if ($(el).val().length > 0) {
                label.addClass('label--active');
            }
        });

        initLabel(input);
    });


    Inputmask.extendDefinitions({
        'n': {
            validator: "[1-9]",
        },
    });

    Inputmask.extendDefinitions({
        'a': {
            validator: "[A-Za-z\u0410-\u044F\u0401\u0404\u0406\u0407\u0451\u0454\u0456\u0457\u0490\u0491\u0027\\u002D\u0020]",
        },
    });

    const phone = $('input[type=tel]'),
        name = $('.name-input'),
        phoneMask = new Inputmask("+38 0n9 999 99 99",  { showMaskOnHover: false, showMaskOnFocus: true }),
        nameMask =  new Inputmask("a{2,50}", { showMaskOnHover: false, showMaskOnFocus: false } );

    phone.each((i, el) => {
        phoneMask.mask(el);
    })

    name.each((i, el) => {
        nameMask.mask(el);
    })

    name.on('change', (ev) => {
        let val = $(ev.currentTarget).val();
        $(ev.currentTarget).val(val.trim());
    })


};
export default forms;